import store from '@/store'

export default {
  /**
   * Remove (previous) error banner when necessary.
   */
  transitionNetworkStatus() {
    const current = store.state.networkResponse && store.state.networkResponse.status || null;
    const statuses = store.state.STATUSES;
    if (current !== statuses.SUCCESS && current !== statuses.SERVER_ERR) {
      // update network status to an intermediate state until the next network call
      store.dispatch('setTransitionalNetworkStatus').then();
    }
  },

  /**
   * IE not supported.
   */
  validateBrowser() {
    const ua = window.navigator.userAgent
    // any IE, including non-Chrome Edge
    const isIE = /Edge\/|Trident\/|MSIE/.test(ua);
    if (isIE) {
      window.location.replace('noie.html');
    }
  }
}
